import { useContext } from 'react'
import { CashierNotification } from '@/contexts'

export const useCashierNotification = () => useContext(CashierNotification)
